import { PiFunnel } from 'react-icons/pi'

import { HelpTooltip } from 'components/Tooltip/HelpTooltip'
import { usePreferences } from 'context/preferences/PreferencesContext'
import type { Campaign } from 'models/campaign'
import { getSourceFilterDrift } from 'models/campaign'

/**
 * Header chip showing the saved target-table filter that produced a
 * campaign's targets (FIR-7843). Renders nothing when the campaign has no
 * linked source filter. Compact per design review: "Filter: <name> (+N)",
 * where (+N) counts targets added outside the filter (manual adds, subset
 * pushes, automations) — the info tooltip carries the full explanation.
 * Shared by the campaign detail and dashboard pages so the two headers
 * cannot drift.
 */
export function CampaignSourceFilterBadge({
  campaign,
}: {
  campaign: Pick<Campaign, 'saved_view' | 'contact_company_count'>
}) {
  const { preferences } = usePreferences()
  const tooltip = preferences?.tooltips?.campaigns_source_filter

  if (!campaign.saved_view) return null

  const drift = getSourceFilterDrift(campaign)

  return (
    <span className="flex items-center gap-1.5 text-sm text-fg-secondary tracking-[-0.2px]">
      <PiFunnel className="size-4 text-brand-active" />
      Filter:{' '}
      <span className="font-medium text-fg">{campaign.saved_view.name}</span>
      {drift > 0 && (
        <span className="text-fg-tertiary">(+{drift.toLocaleString()})</span>
      )}
      {tooltip && (
        <HelpTooltip title={tooltip.title} content={tooltip.content} />
      )}
    </span>
  )
}
